function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  d: "M4.638 9.922L4.54 11.9a4.325 4.325 0 00-.354-.035c-2.192-.1-4.052 1.54-4.158 3.668-.105 2.127 1.586 3.935 3.776 4.037.16.008.315.003.47-.007.418 4.763 3.751 8.774 8.328 10.248l-.15 3.025c-.096 1.945 1.308 3.798 3.43 3.897 2.12.099 3.7-1.615 3.796-3.561.014-.259.098-1.992.16-3.216 4.388-1.224 7.803-4.777 8.652-9.255.129.018.26.03.394.037 2.192.103 4.054-1.54 4.159-3.667.105-2.128-1.586-3.935-3.779-4.037-.095-.005-.188-.002-.283 0l.097-1.974C29.402 4.507 24.092 1.003 17.342.69c-.32-.016-.638-.023-.952-.023-6.32 0-11.445 3.012-11.752 9.256",
  id: "benefit_family_svg__c"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4.638 9.922L4.54 11.9a4.325 4.325 0 00-.354-.035c-2.192-.1-4.052 1.54-4.158 3.668-.105 2.127 1.586 3.935 3.776 4.037.16.008.315.003.47-.007.418 4.763 3.751 8.774 8.328 10.248l-.15 3.025c-.096 1.945 1.308 3.798 3.43 3.897 2.12.099 3.7-1.615 3.796-3.561.014-.259.098-1.992.16-3.216 4.388-1.224 7.803-4.777 8.652-9.255.129.018.26.03.394.037 2.192.103 4.054-1.54 4.159-3.667.105-2.128-1.586-3.935-3.779-4.037-.095-.005-.188-.002-.283 0l.097-1.974C29.402 4.507 24.092 1.003 17.342.69c-.32-.016-.638-.023-.952-.023-6.32 0-11.445 3.012-11.752 9.256",
  id: "benefit_family_svg__e"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4.638 9.922L4.54 11.9a4.325 4.325 0 00-.354-.035c-2.192-.1-4.052 1.54-4.158 3.668-.105 2.127 1.586 3.935 3.776 4.037.16.008.315.003.47-.007.418 4.763 3.751 8.774 8.328 10.248l-.15 3.025c-.096 1.945 1.308 3.798 3.43 3.897 2.12.099 3.7-1.615 3.796-3.561.014-.259.098-1.992.16-3.216 4.388-1.224 7.803-4.777 8.652-9.255.129.018.26.03.394.037 2.192.103 4.054-1.54 4.159-3.667.105-2.128-1.586-3.935-3.779-4.037-.095-.005-.188-.002-.283 0l.097-1.974C29.402 4.507 24.092 1.003 17.342.69c-.32-.016-.638-.023-.952-.023-6.32 0-11.445 3.012-11.752 9.256",
  id: "benefit_family_svg__g"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4.638 9.922L4.54 11.9a4.325 4.325 0 00-.354-.035c-2.192-.1-4.052 1.54-4.158 3.668-.105 2.127 1.586 3.935 3.776 4.037.16.008.315.003.47-.007.418 4.763 3.751 8.774 8.328 10.248l-.15 3.025c-.096 1.945 1.308 3.798 3.43 3.897 2.12.099 3.7-1.615 3.796-3.561.014-.259.098-1.992.16-3.216 4.388-1.224 7.803-4.777 8.652-9.255.129.018.26.03.394.037 2.192.103 4.054-1.54 4.159-3.667.105-2.128-1.586-3.935-3.779-4.037-.095-.005-.188-.002-.283 0l.097-1.974C29.402 4.507 24.092 1.003 17.342.69c-.32-.016-.638-.023-.952-.023-6.32 0-11.445 3.012-11.752 9.256",
  id: "benefit_family_svg__i"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4.54 11.9a4.325 4.325 0 00-.354-.035c-2.192-.1-4.052 1.54-4.158 3.668-.105 2.127 1.586 3.935 3.776 4.037.16.008.315.003.47-.007.418 4.763 3.751 8.774 8.328 10.248l-.15 3.025c-.096 1.945 1.308 3.798 3.43 3.897 2.12.099 3.7-1.615 3.796-3.561.014-.259.098-1.992.16-3.216 4.388-1.224 7.803-4.777 8.652-9.255.129.018.26.03.394.037 2.192.103 4.054-1.54 4.159-3.667.105-2.128-1.586-3.935-3.779-4.037-.095-.005-.188-.002-.283 0l.097-1.974C29.402 4.507 24.092 1.003 17.342.69c-.32-.016-.638-.023-.952-.023-6.32 0-11.445 3.012-11.752 9.256L4.54 11.9z",
  id: "benefit_family_svg__k"
}), /*#__PURE__*/React.createElement("rect", {
  id: "benefit_family_svg__a",
  x: 0,
  y: 0,
  width: 90,
  height: 90,
  rx: 45
}));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(1)",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(10)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "benefit_family_svg__b",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#benefit_family_svg__a"
})), /*#__PURE__*/React.createElement("use", {
  fill: "#DA4D7A",
  xlinkHref: "#benefit_family_svg__a"
}), /*#__PURE__*/React.createElement("use", {
  fillOpacity: 0.9,
  fill: "#FFF",
  xlinkHref: "#benefit_family_svg__a"
}), /*#__PURE__*/React.createElement("g", {
  mask: "url(#benefit_family_svg__b)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M49.934 60.665c-5.166 1.27-8.994 5.8-8.994 11.21v20.948h17.988V71.874c0-5.41-3.828-9.94-8.994-11.21",
  fill: "#FFF"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#D85C41",
  d: "M55.845 90.063h-4.182v-21.93l2.09-2.029 2.092 2.03z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M39.479 104.885h-8.364V82.676c0-10.93 7.226-19.71 17.982-21.847l1.676 7.957c-6.966 1.384-11.294 6.706-11.294 13.89v22.21z",
  fill: "#FFF"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#70502D",
  d: "M16.815 67.608h29.65V46.802h-29.65z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M38.388 103.829V76.418c0-5.58-3.877-10.277-9.155-11.7-5.279 1.423-9.154 6.12-9.154 11.7v27.41c0 5.58 3.875 10.277 9.154 11.7 5.278-1.423 9.155-6.12 9.155-11.7",
  fill: "#BB9DD6"
}), /*#__PURE__*/React.createElement("path", {
  d: "M20.084 95.847l-10.493-9.22c-1.555-1.367-1.89-3.616-.796-5.354.914-1.454 9.23-14.262 19.743-16.35l1.751 8.31c-4.394.873-9.167 5.947-12.001 9.596l7.658 6.73-5.862 6.288z",
  fill: "#BB9DD6"
}), /*#__PURE__*/React.createElement("path", {
  d: "M37.198 65.129a12.858 12.858 0 00-7.966-.411c2.598.7 4.853 2.196 6.477 4.198a11.904 11.904 0 012.53 5.67c.092.598.147 1.207.147 1.83v27.413c0 5.578-3.875 10.275-9.154 11.698 1.068.288 2.191.445 3.352.445 6.909 0 12.508-5.437 12.508-12.143v-8.145l-.13.114.13-11.39v-7.992c0-5.124-3.271-9.504-7.894-11.287",
  fill: "#AB85D3"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#E2E2E2",
  d: "M64.786 92.906V91.66l-.883 1.246zM58.87 70.775c.036.362.057.728.057 1.099V90.16c1.4-.493 2.557-.92 3.437-1.252.794-5.568.55-15.004-3.493-18.133"
}), /*#__PURE__*/React.createElement("path", {
  d: "M56.988 60.915l-.03.099-.997 3.243c1.608 1.775 2.668 4.028 2.91 6.518 3.032 4.152 2.429 9.126 1.633 14.695-.88.332-2.037.758-3.435 1.252-3.512 1.238-6.74 2.14-13.17 3.951l2.328 7.801c8.08-2.274 12.224-3.558 15.817-4.875.312-.115.606-.224.883-.328a92.658 92.658 0 002.991-1.165c1.295-.541 2.22-1.679 2.466-3.027 2.687-14.846.086-24.837-11.396-28.164",
  fill: "#FFF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M54.114 82.958c-.153-6.985-7.066-14.571-15.487-17.165 3.853 2.07 6.465 6.047 6.465 10.623v4.327c.422.873.66 1.713.66 2.453 0 .143.008.284.023.426v6.5l8.34-2.328v-4.836z",
  fill: "#AB85D3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M45.092 76.416c0-4.576-2.613-8.554-6.464-10.623l-1.647 5.04c.557 1.04.956 2.172 1.183 3.364 3.217 1.55 5.78 4.17 6.928 6.546v-4.326z",
  fill: "#AB85D3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M21.571 73.753l-.017.014c-.682.572-1.755.455-2.396-.264l-2.385-2.667c-.636-.711-.61-1.746.056-2.32a.247.247 0 00.016-.015c.682-.572 1.755-.454 2.397.263l2.384 2.667c.637.712.61 1.747-.055 2.322",
  fill: "#C98D62"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19.069 75.502l-.017.014c-.681.572-1.754.454-2.396-.263l-2.386-2.668c-.635-.711-.609-1.746.057-2.32l.016-.016c.682-.571 1.755-.453 2.397.264l2.384 2.668c.637.711.61 1.746-.055 2.32",
  fill: "#C98D62"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.755 77.546l-.017.014c-.681.572-1.754.454-2.396-.264l-2.386-2.667c-.641-.717-.61-1.76.072-2.335.682-.573 1.755-.455 2.397.263l2.385 2.667c.636.712.61 1.746-.055 2.322",
  fill: "#C98D62"
}), /*#__PURE__*/React.createElement("path", {
  d: "M21.403 73.57l-.017.013c-.681.572-1.754.455-2.396-.263l-2.385-2.667c-.637-.712-.61-1.746.056-2.321l.016-.015c.683-.571 1.756-.454 2.397.264l2.384 2.667c.637.712.61 1.746-.055 2.321",
  fill: "#DBA279"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.9 75.318l-.017.015c-.68.571-1.754.454-2.395-.264l-2.386-2.667c-.636-.712-.609-1.747.057-2.322l.016-.014c.682-.572 1.754-.454 2.396.263l2.385 2.668c.637.712.61 1.746-.056 2.321",
  fill: "#DBA279"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.586 77.362c-.006.005-.01.01-.017.014-.681.572-1.754.455-2.396-.264l-2.385-2.666c-.642-.718-.615-1.766.072-2.336.682-.572 1.755-.455 2.397.264l2.385 2.666c.636.713.61 1.747-.056 2.322",
  fill: "#DBA279"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19.332 73.59l-.003.002c-.05.04-.127.03-.171-.023l-2.135-2.508c-.045-.052-.041-.128.01-.166.05-.04.127-.029.17.023l2.136 2.508c.043.05.04.124-.007.163M17.102 75.63l-.001.002c-.05.041-.126.033-.171-.02l-2.294-2.566c-.045-.05-.05-.123.006-.167.048-.04.126-.032.171.02l2.293 2.567c.046.05.044.124-.004.165",
  fill: "#C98D62"
}), /*#__PURE__*/React.createElement("path", {
  d: "M41.707 35.772c.339-6.857 6.338-12.15 13.401-11.82 7.063.33 12.513 6.154 12.175 13.012-.339 6.857-6.339 12.15-13.402 11.82-7.062-.329-12.513-6.154-12.174-13.012",
  fill: "#3F2D0D"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
  transform: "translate(37.535 28.665)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "benefit_family_svg__d",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#benefit_family_svg__c"
})), /*#__PURE__*/React.createElement("path", {
  d: "M17.342.689C10.592.374 4.961 3.369 4.637 9.922L4.24 17.97c-.325 6.553 4.886 12.12 11.635 12.434 6.748.315 12.482-4.743 12.806-11.296l.398-8.048C29.402 4.507 24.092 1.003 17.342.69",
  fill: "#C98D62",
  mask: "url(#benefit_family_svg__d)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(37.535 28.665)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "benefit_family_svg__f",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#benefit_family_svg__e"
})), /*#__PURE__*/React.createElement("path", {
  d: "M19.678 33.172c-.095 1.946-1.676 3.66-3.797 3.56-2.12-.098-3.525-1.95-3.428-3.896l.219-4.443 7.225.338s-.2 4.035-.219 4.441",
  fill: "#C98D62",
  mask: "url(#benefit_family_svg__f)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(37.535 28.665)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "benefit_family_svg__h",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#benefit_family_svg__g"
})), /*#__PURE__*/React.createElement("path", {
  d: "M.028 15.533c.105-2.127 1.967-3.769 4.158-3.668 2.19.102 3.882 1.91 3.777 4.038-.105 2.127-1.966 3.769-4.158 3.667-2.191-.102-3.882-1.91-3.777-4.037",
  fill: "#804D4B",
  mask: "url(#benefit_family_svg__h)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(37.535 28.665)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "benefit_family_svg__j",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#benefit_family_svg__i"
})), /*#__PURE__*/React.createElement("path", {
  d: "M25.107 16.701c.105-2.127 1.967-3.769 4.158-3.667 2.192.101 3.882 1.909 3.777 4.037-.105 2.127-1.966 3.769-4.157 3.667-2.191-.102-3.882-1.91-3.778-4.037",
  fill: "#C98D62",
  mask: "url(#benefit_family_svg__j)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(37.535 28.665)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "benefit_family_svg__l",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#benefit_family_svg__k"
})), /*#__PURE__*/React.createElement("path", {
  d: "M13.193-1.573C6.443-1.888.813 1.107.488 7.66L.09 15.708c-.324 6.553 4.886 12.12 11.635 12.435 6.75.315 12.483-4.743 12.806-11.297L24.93 8.8c.324-6.554-4.987-10.057-11.737-10.372",
  fill: "#DBA279",
  mask: "url(#benefit_family_svg__l)"
}))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M54.967 52.66a5.997 5.997 0 01-.958.03 5.96 5.96 0 01-3.747-1.545.342.342 0 01-.015-.491.367.367 0 01.506-.015 5.23 5.23 0 003.29 1.358 5.256 5.256 0 003.41-1.046.364.364 0 01.5.061.34.34 0 01-.062.488 5.971 5.971 0 01-2.924 1.16",
  fill: "#D47742"
}), /*#__PURE__*/React.createElement("path", {
  d: "M61.357 43.092c-.035.708-.444 1.27-.908 1.248-.464-.021-.816-.618-.78-1.326.035-.71.443-1.271.907-1.25.465.022.815.62.78 1.328M49.355 42.533c-.035.709-.443 1.27-.908 1.249-.464-.022-.816-.619-.78-1.328.036-.708.444-1.27.908-1.248.465.022.816.619.78 1.327",
  fill: "#000"
}), /*#__PURE__*/React.createElement("path", {
  d: "M55.182 26.926c-4.382-.204-8.011 1.178-8.105 3.088-.095 1.91 3.381 3.622 7.763 3.826 2.967.139 5.59-.45 7.001-1.438 0 0 4.065-2.614 4.253-7.88-2.67 2.806-6.209 3.502-10.912 2.404",
  fill: "#3F2D0D"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.815 46.801c0-7.935 6.626-14.369 14.799-14.369 8.174 0 14.8 6.434 14.8 14.37 0 7.935-6.626 14.368-14.8 14.368-8.173 0-14.799-6.433-14.799-14.369",
  fill: "#A06F37"
}), /*#__PURE__*/React.createElement("path", {
  d: "M45.373 50.003c-.071 0-.138.015-.208.02-.471-5.427-4.395-9.895-9.632-11.329 3.446 2.333 5.705 6.204 5.705 10.592v.026c0 7.131-5.954 12.912-13.298 12.912h-.237c-1.234 0-2.422-.176-3.558-.48a13.433 13.433 0 004.096 1.859v2.596c0 1.919 1.47 3.678 3.564 3.678 2.091 0 3.564-1.76 3.564-3.678v-2.596c4.37-1.138 7.853-4.37 9.22-8.53.25.075.51.127.784.127 1.478 0 2.676-1.164 2.676-2.599 0-1.435-1.198-2.598-2.676-2.598",
  fill: "#ECB389"
}), /*#__PURE__*/React.createElement("path", {
  d: "M27.94 62.224c7.344 0 13.3-5.78 13.3-12.913v-.025c0-4.388-2.261-8.259-5.707-10.592a13.639 13.639 0 00-3.61-.488h-.237c-6.958 0-12.66 5.19-13.24 11.801-1.456.025-2.63 1.174-2.63 2.594 0 1.435 1.198 2.599 2.676 2.599.19 0 .375-.021.554-.057.91 2.713 2.731 5.012 5.1 6.6 1.134.306 2.323.481 3.557.481h.237z",
  fill: "#FABE92"
}), /*#__PURE__*/React.createElement("path", {
  d: "M31.614 58.074c1.38 0 2.716-.48 3.763-1.35a.335.335 0 00.039-.482.358.358 0 00-.497-.038 5.175 5.175 0 01-3.305 1.186 5.167 5.167 0 01-3.304-1.186.358.358 0 00-.497.038.334.334 0 00.039.482 5.885 5.885 0 003.762 1.35",
  fill: "#D47742"
}), /*#__PURE__*/React.createElement("path", {
  d: "M37.642 50.938c.458 0 .833-.572.833-1.27 0-.7-.375-1.27-.833-1.27-.459 0-.833.57-.833 1.27 0 .698.374 1.27.833 1.27M26.224 48.397c-.459 0-.834.571-.834 1.27 0 .7.375 1.27.834 1.27.457 0 .832-.57.832-1.27 0-.699-.375-1.27-.832-1.27",
  fill: "#000"
}), /*#__PURE__*/React.createElement("path", {
  d: "M23.094 36.024c2.617 5.083 14.964 13.747 22.01 11.01 1.209-2.933-.2-5.474-.2-5.474l-9.528-8.078-12.282 2.542z",
  fill: "#A06F37"
}), /*#__PURE__*/React.createElement("path", {
  d: "M27.729 39.282c-2.338 5.984-6.35 8.122-10.113 9.909-.625-1.513 1.2-8.662 1.2-8.662l3.745-2.422 5.168 1.175z",
  fill: "#A06F37"
})))), /*#__PURE__*/React.createElement("path", {
  fill: "#45C94E",
  d: "M84 36h33v15H84z"
}), /*#__PURE__*/React.createElement("circle", {
  fill: "#DA4D7A",
  cx: 105,
  cy: 83,
  r: 5
}), /*#__PURE__*/React.createElement("path", {
  d: "M100 6c.592 0 1.071.48 1.071 1.071v2.857h2.858c.552 0 1.007.418 1.065.955L105 11c0 .592-.48 1.071-1.071 1.071h-2.858v2.858c0 .552-.417 1.007-.954 1.065L100 16c-.592 0-1.071-.48-1.071-1.071l-.001-2.858h-2.857a1.072 1.072 0 01-1.065-.954L95 11c0-.592.48-1.071 1.071-1.071l2.857-.001V7.071c0-.552.418-1.007.955-1.065z",
  fill: "#F9BA48",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10 83c.592 0 1.071.48 1.071 1.071v2.857h2.858c.552 0 1.007.418 1.065.955L15 88c0 .592-.48 1.071-1.071 1.071H11.07v2.858c0 .552-.417 1.007-.954 1.065L10 93c-.592 0-1.071-.48-1.071-1.071l-.001-2.858H6.071a1.072 1.072 0 01-1.065-.954L5 88c0-.592.48-1.071 1.071-1.071l2.857-.001v-2.857c0-.552.418-1.007.955-1.065z",
  fill: "#0086D8",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5 16A5 5 0 105 6a5 5 0 000 10z",
  stroke: "#45C94E",
  strokeWidth: 2
}));

function SvgBenefitFamily(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 118,
    height: 93,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _ref, _ref2);
}

export default __webpack_public_path__ + "static/benefit_family.e7b263a2.svg";
export { SvgBenefitFamily as ReactComponent };